const packageName = 'case-connector';
const version = '0.30.1'; // x-release-please-version

export const versionString = `${packageName}@${version}`;
